<app-add-form
  data-testid="purchase-request-edit-form"
  #addForm
  [title]="'purchase_request.actions.edit_purchase_request' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="saving()"
  [initialData]="currentFormData"
  [getFieldError]="getFieldError"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- Actions Template for Items table -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <span
        [attr.data-testid]="'purchase-request-edit-action-delete-item-' + rowData.id"
        (click)="onTableAction({ action: 'deleteItem', data: rowData })"
        class="action-link action-delete cursor-pointer"
      >
        {{ "purchase_request.actions.delete" | translate }}
      </span>
    </div>
  </ng-template>
</app-add-form>

<!-- Item Dialog -->
<app-purchase-request-item-dialog
  data-testid="purchase-request-edit-item-dialog"
  [(visible)]="showItemDialog"
  [initialData]="editingItem()"
  [editMode]="!!editingItem()"
  [existingItems]="itemsList()"
  (confirm)="onItemDialogConfirm($event)"
  (visibleChange)="showItemDialog.set($event)"
></app-purchase-request-item-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-request-edit-toast"></p-toast>
